/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */
import Index from '@/views/Home/Index.vue';
import Order from '@/views/Order/Index.vue';
import Redirect from '@/views/Order/Redirect.vue';
import { ROUTE_UNIT_LIST } from '@/routes/enum';

export default [
  // Home
  {
    path: '/home',
    name: 'home.index',
    component: Index,

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },
  {
    path: '/:order',
    component: Order,
    meta: {
      auth: false,
    },
    children: [
      {
        path: '',
        name: 'order.redirect',
        component: Redirect,
        props: false,
      },
      // Home 2
      {
        path: 'home',
        name: 'order.home',
        component: Index,
        props: true,
        // If the user needs to be authenticated to view this page
        meta: {
          auth: false,
        },
      },

      // Overview
      {
        path: 'overview/:exteriorId?',
        // path: '/:order/overview',
        name: 'order.overview.exterior',
        component: () => import('@/views/Order/Overview.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
      {
        // path: '/:order/overview/?:exteriorId',
        path: 'overview',
        name: 'order.overview',
        component: () => import('@/views/Order/Overview.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
      // Unit list
      {
        path: ROUTE_UNIT_LIST,
        name: 'order.unit-list',
        component: () => import('@/views/Order/UnitListView.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
      // Units
      {
        path: 'units',
        name: 'order.units',
        component: () => import('@/views/Order/Units.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
      // Units
      {
        path: 'units/unit/:unitId/:exteriorId?',
        name: 'order.unit.view',
        component: () => import('@/views/Order/UnitSingle.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
      // Gallery
      {
        path: 'gallery',
        alias: 'imagesvideos',
        name: 'order.gallery',
        component: () => import('@/views/Order/Gallery.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
      // Panoramas
      {
        path: 'panoramas/:id',
        name: 'order.panoramas',
        component: () => import('@/views/Order/Panoramas.vue'),
        props: true,

        meta: {
          auth: false,
        },
      },
      // Panoramas
      {
        path: 'panoramas/:id/:panoramaOrderId',
        name: 'order.panorama.view',
        component: () => import('@/views/Order/PanoramaSingle.vue'),
        props: true,
        meta: {
          auth: false,
        },
      },
      {
        path: 'unit-panorama/:panoramaOrderId',
        name: 'order.panorama.unit-view',
        component: () => import('@/views/Order/UnitPanoramaSingle.vue'),
        props: true,
        meta: {
          auth: false,
        },
      },
      {
        path: 'native-panorama/:unitType/:hotspot?',
        name: 'order.native-panorama.view',
        component: () => import('@/views/Order/NativePanorama.vue'),
        props: ({ params: { unitType, hotspot = 0 } }) => ({
          unitTypeId: +unitType,
          hotspotId: +hotspot,
        }),
        meta: {
          auth: false,
        },
      },
      // Area
      {
        path: 'area',
        name: 'order.area',
        component: () => import('@/views/Order/Area.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
      // Contact
      {
        path: 'contact',
        name: 'order.contact',
        component: () => import('@/views/Order/Contact.vue'),
        props: true,

        // If the user needs to be a guest to view this page.
        meta: {
          auth: false,
        },
      },
    ],
  },
  {
    path: '/',
    redirect: '/home',
  },
];
